import React from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import CategorySlider from "../../../CategorySlider";


/* ================= TELANGANA CITY DATA ================= */

const telanganaCities = [
  { slug: "hyderabad", city: "Hyderabad", state: "Telangana" },
  { slug: "secunderabad", city: "Secunderabad", state: "Telangana" },
  { slug: "warangal", city: "Warangal", state: "Telangana" },
  { slug: "nizamabad", city: "Nizamabad", state: "Telangana" },
  { slug: "karimnagar", city: "Karimnagar", state: "Telangana" }
];

const Telangana = () => {
  const { city } = useParams();

  /* ================= STATE PAGE ================= */
  if (!city) {
    return (
      <div style={{  backgroundColor: "#FFF5F5", marginTop: "90px", padding: "25px", lineHeight: "1.8" }}>
        <h1>Sex Toys Delivery in Telangana</h1>

        <p>
          Buy premium <strong>sex toys in Telangana</strong> with fast and
          discreet delivery. LushDesire is a trusted Indian adult wellness store
          offering genuine products for men, women, and couples across Telangana.
        </p>

        <h2>Cities We Serve in Telangana</h2>

        <ul>
          {telanganaCities.map((c) => (
            <li key={c.slug}>
              <Link to={`/sex-toys-delivery/telangana/${c.slug}`}>
                Sex Toys in {c.city}
              </Link>
            </li>
          ))}
        </ul>

        <h3>Why Buy Sex Toys Online from LushDesire?</h3>
        <p>
          We focus on customer privacy, product quality, and fast shipping. All
          orders are packed in plain boxes and delivered safely across Telangana.
        </p>
      </div>
    );
  }

  /* ================= CITY PAGE ================= */
  const cityData = telanganaCities.find((c) => c.slug === city);

  if (!cityData) {
    return (
      <div style={{  backgroundColor: "#FFF5F5", marginTop: "120px", padding: "30px" }}>
        <h2>City not found</h2>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          Sex Toys in {cityData.city} | Discreet Delivery in Telangana
        </title>
        <meta
          name="description"
          content={`Buy sex toys in ${cityData.city} with fast & discreet delivery. Premium adult toys and couples wellness products available across Telangana.`}
        />
      </Helmet>
      <CategorySlider />


      <div style={{   backgroundColor: "#FFF5F5", padding: "25px", lineHeight: "1.8" }}>
        {/* H1 */}
        <h1>Sex Toys in {cityData.city} – Safe & Private Delivery</h1>

        <p>
          Looking to buy <strong>sex toys in {cityData.city}</strong>? LushDesire
          offers premium, body-safe adult toys with 100% discreet packaging and
          fast delivery across Telangana.
        </p>

        {/* H2 */}
        <h2>Buy Sex Toys Online in {cityData.city}</h2>
        <p>
          Shopping for adult toys in {cityData.city} is now simple, safe, and
          confidential. We provide a wide range of pleasure and wellness
          products designed to enhance intimacy and confidence.
        </p>

        {/* H3 */}
        <h3>Popular Sex Toys Available in {cityData.city}</h3>
        <ul>
          <li>✔ Vibrators & Bullet Massagers</li>
          <li>✔ Dildos & Realistic Toys</li>
          <li>✔ Couples Sex Toys</li>
          <li>✔ Male Masturbators</li>
          <li>✔ Female Pleasure & Wellness Products</li>
        </ul>

        {/* H3 */}
        <h3>Why Choose LushDesire in {cityData.city}?</h3>
        <ul>
          <li>✔ 100% Discreet & Plain Packaging</li>
          <li>✔ Fast Delivery in {cityData.city}</li>
          <li>✔ Cash on Delivery Available</li>
          <li>✔ Secure Online Payments</li>
          <li>✔ Trusted Indian Adult Store</li>
        </ul>

        {/* H4 */}
        <h4>Discreet Sex Toys Delivery Across Telangana</h4>
        <p>
          All orders are shipped in plain packaging with no adult branding. We
          deliver safely across {cityData.city}, Hyderabad, Secunderabad,
          Warangal, Nizamabad, Karimnagar, and nearby areas.
        </p>

        {/* H4 */}
        <h4>Who Can Buy Sex Toys from LushDesire?</h4>
        <p>
          Our products are suitable for beginners as well as experienced users.
          Whether shopping solo or as a couple, we ensure privacy, quality, and
          reliable service.
        </p>

        {/* H5 */}
        <h5>Frequently Asked Questions</h5>
        <p>
          <strong>Is delivery discreet?</strong> Yes, all orders are packed
          privately.<br />
          <strong>Is COD available?</strong> Yes, Cash on Delivery is available
          in most locations of {cityData.city}.<br />
          <strong>Are products genuine?</strong> Yes, we sell only original,
          body-safe products.
        </p>

        {/* H5 */}
        <h5>Order Sex Toys in {cityData.city} Today</h5>
        <p>
          Order today from LushDesire and enjoy premium adult wellness products
          with fast delivery, complete privacy, and trusted service.
        </p>

        <p>
          <strong>LushDesire</strong> – Trusted Online Sex Toy Store in Telangana.
        </p>
      </div>
    </>
  );
};

export default Telangana;
